module.exports = __webpack_public_path__ + "img/viessmann-heating-system-md.08f850d4.svg";